import { Link } from "@backstage/ui";
import { LogoFull, LogoIcon } from "@internal/backstage-plugin-app-react";

import styles from "./SidebarLogo.module.css";
import { useSidebarOpen } from "./sidebarOpenState";

/**
 * Home link at the top of the nav rail.
 *
 * Shows the full wordmark when the rail is expanded and the mark alone when it
 * is collapsed. Open state now comes from {@link useSidebarOpen} rather than
 * `useSidebarOpenState`, which was published by the Material UI sidebar this
 * module no longer renders.
 *
 * The accessible name is "Backstage home" rather than plain "Home" so it does
 * not collide with the Home nav item a few rows below, which points at the
 * same destination. Two links with the same name are ambiguous when navigating
 * by landmark or link list.
 */
export const SidebarLogo = () => {
    const isOpen = useSidebarOpen();

    return (
        <div className={styles.container} data-open={isOpen}>
            <Link href="/" aria-label="Backstage home" className={styles.link}>
                {isOpen ? <LogoFull /> : <LogoIcon />}
            </Link>
        </div>
    );
};
